const QUOTA_ERROR_NAMES = new Set(["QuotaExceededError", "NS_ERROR_DOM_QUOTA_REACHED"]);

export const isStorageQuotaError = (error) =>
  error &&
  (QUOTA_ERROR_NAMES.has(error.name) ||
    error.code === 22 ||
    error.code === 1014);

export const getStoredJSON = (key, fallback = null) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    console.warn(`Unable to read ${key} from localStorage. Clearing stale value.`, error);
    localStorage.removeItem(key);
    return fallback;
  }
};

export const setStoredJSON = (key, value, { maxBytes = 750000, evictPrefixes = [] } = {}) => {
  try {
    const payload = JSON.stringify(value);

    if (payload.length > maxBytes) {
      console.info(`Skipping localStorage cache for ${key}; payload is too large.`);
      localStorage.removeItem(key);
      return false;
    }

    localStorage.setItem(key, payload);
    return true;
  } catch (error) {
    if (isStorageQuotaError(error)) {
      evictPrefixes.forEach((prefix) => {
        Object.keys(localStorage)
          .filter((storageKey) => storageKey.startsWith(prefix))
          .forEach((storageKey) => localStorage.removeItem(storageKey));
      });
      console.warn(`Skipped localStorage cache for ${key}; browser storage quota is full.`);
      return false;
    }

    throw error;
  }
};
